import React from 'react';
import { Link } from 'react-router-dom';
import './Careers.css';
import { careers, principles, offices } from '../data/site';

const benefits = [
  { title: 'Senior bar', text: 'Hire only senior. Pair on hard things. Mentor relentlessly.' },
  { title: 'Real ownership', text: 'You ship. You own. You are credited.' },
  { title: 'Top-of-market comp', text: 'Comp and equity benchmarked to top-of-market every year.' },
  { title: 'Time to think', text: 'Two paid research weeks per engineer per year.' },
  { title: 'Founder-stage equity', text: 'Real equity in a year-one company that is already shipping.' },
  { title: 'Real on-call', text: 'Real systems. Real on-call. Real engineering pride.' },
];

const Careers = () => {
  return (
    <div className="careers-page page-shell">
      <section className="cr-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Careers</span>
          <h1>
            Build production AI <span className="gradient-text serif-accent">with senior practitioners.</span>
          </h1>
          <p>
            Dalytix is a high-bar, high-trust engineering organization. We hire senior, ship hard, and
            stay close to the systems we build. If you are curious about the work, scroll on.
          </p>
          <div className="cr-stats">
            <div><strong>100%</strong><span>senior-led delivery model</span></div>
            <div><strong>3</strong><span>delivery hubs · London, New York &amp; Remote</span></div>
            <div><strong>4.9</strong><span>internal team rating (real)</span></div>
            <div><strong>100%</strong><span>seniors-only hiring bar</span></div>
          </div>
        </div>
      </section>

      <section className="section cr-roles-section">
        <div className="site-container-wide">
          <span className="section-eyebrow">Open roles</span>
          <h2 className="section-title">6 roles. Senior bar. Direct hiring.</h2>
          <p className="section-lead">
            All roles are senior. All hiring is direct (no agencies). Most processes close in two weeks.
          </p>
          <div className="cr-roles-grid">
            {careers.map((role) => (
              <article className="cr-role professional-card" key={role.role}>
                <div className="cr-role-head">
                  <h3>{role.role}</h3>
                  <span className="cr-role-type">{role.type}</span>
                </div>
                <span className="cr-role-loc">📍 {role.location}</span>
                <p>{role.description}</p>
                <Link to={`/contact?topic=Career%20inquiry&role=${encodeURIComponent(role.role)}`} className="learn-more">Apply →</Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section cr-benefits section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">Why Dalytix</span>
          <h2 className="section-title">What working here actually looks like.</h2>
          <div className="cr-benefits-grid">
            {benefits.map((b) => (
              <article className="cr-benefit glass-card" key={b.title}>
                <h3>{b.title}</h3>
                <p>{b.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section cr-principles">
        <div className="site-container-wide">
          <span className="section-eyebrow">How we operate</span>
          <h2 className="section-title">Six principles every Dalytix engineer carries.</h2>
          <div className="cr-principles-grid">
            {principles.map((p) => (
              <article className="cr-principle professional-card" key={p.title}>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section cr-offices section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">Where we work</span>
          <h2 className="section-title">Three hubs. Hybrid by default. Remote welcome.</h2>
          <div className="cr-offices-grid">
            {offices.map((o) => (
              <article className="cr-office glass-card" key={o.city}>
                <img src={o.image} alt={o.city} />
                <div>
                  <strong>{o.city}</strong>
                  <span>{o.region}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="cr-cta">
        <div className="site-container-wide professional-card">
          <h2>Did not see your role?</h2>
          <p>We are always hiring senior practitioners. If you can ship, we want to hear from you.</p>
          <Link to="/contact" className="btn-primary-large">Send your introduction</Link>
        </div>
      </section>
    </div>
  );
};

export default Careers;
